import { useNavigate } from 'react-router-dom';
import { CONST_ROUTE_PATH } from '../../route/RouteConstants';

const LockIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

/**
 * Shows the first few items, then blurs the rest behind an upgrade prompt -
 * the same treatment Table.jsx gives gated rows, for content that isn't a table.
 *
 * The hidden items are never rendered, so their data doesn't reach the DOM.
 *
 * @param {boolean} locked        when false, everything renders normally
 * @param {React.ReactNode[]} items
 * @param {number} teaserCount    how many items stay fully visible
 * @param {string} title
 * @param {string} subtitle
 */
/**
 * The upgrade prompt itself, positioned over whatever it's placed inside.
 */
const UpgradeOverlay = ({ title, subtitle, height = '72%', minHeight = '150px' }) => {
  const navigate = useNavigate();

  return (
    <div style={{
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height,
      minHeight,
      background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(248,249,252,0.96) 22%, rgba(248,249,252,1) 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      textAlign: 'center',
      padding: '0 16px',
      zIndex: 5,
    }}>
      <div style={{ color: 'var(--brand, #ff6b2b)', opacity: 0.9 }}>
        <LockIcon />
      </div>
      <div style={{ fontSize: '14px', fontWeight: 700, color: 'var(--text, #1a2035)' }}>
        {title}
      </div>
      <div style={{ fontSize: '12px', color: 'var(--muted, #7a8499)', maxWidth: '260px', lineHeight: 1.5 }}>
        {subtitle}
      </div>
      <button
        onClick={() => navigate(CONST_ROUTE_PATH.PRICING)}
        style={{
          marginTop: '2px',
          padding: '7px 20px',
          background: 'var(--brand, #ff6b2b)',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 4px 14px rgba(255,107,43,0.35)',
        }}
      >
        View Plans →
      </button>
    </div>
  );
};

const PlanGate = ({
  locked = false,
  items = [],
  teaserCount = 2,
  title = 'Upgrade to see all recommendations',
  subtitle = 'Your current plan shows a preview only.',
}) => {

  if (!locked) return <>{items}</>;

  const teaser = items.slice(0, teaserCount);
  const hiddenCount = Math.max(0, items.length - teaser.length);

  return (
    <div style={{ position: 'relative' }}>
      {teaser}

      {/* Placeholder bars - shape only, no real values */}
      <div style={{ filter: 'blur(6px)', pointerEvents: 'none', userSelect: 'none', opacity: 0.75 }} aria-hidden="true">
        {Array.from({ length: Math.max(2, Math.min(hiddenCount, 4)) }).map((_, i) => (
          <div key={`plan-gate-ghost-${i}`} className="rec-item">
            <div className="rec-item-top">
              <span className="rec-item-title">{'█'.repeat(8 + ((i * 5) % 7))}</span>
              <span className="rec-item-amt">{'█'.repeat(5)}</span>
            </div>
          </div>
        ))}
      </div>

      <UpgradeOverlay title={title} subtitle={subtitle} />
    </div>
  );
};

export default PlanGate;
